export default __webpack_public_path__ + "static/media/avatar_rob_winter.9c084d8b.svg";